var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-card",
        { staticClass: "soli-round" },
        [
          _c(
            "v-container",
            { staticClass: "px-3", attrs: { fluid: "" } },
            [
              _c("v-data-table", {
                ref: "table",
                attrs: {
                  headers: _vm.headers,
                  items: _vm.people || [],
                  "disable-pagination": "",
                  "hide-default-footer": "",
                  "show-select": "",
                  "mobile-breakpoint": "0",
                  search: _vm.search,
                  loading: !_vm.people,
                  groupBy: _vm.groupBy,
                },
                on: {
                  "current-items": function ($event) {
                    _vm.currentItems = $event
                  },
                  "click:row": function ($event) {
                    return _vm.$log($event.id)
                  },
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "top",
                      fn: function () {
                        return [
                          _c(
                            "div",
                            {
                              staticClass:
                                "font-semibold soli-grey text-lg py-2 px-4",
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    `${
                                      _vm.selectedPeople.length
                                        ? `Selected: ${_vm.selectedPeople.length} `
                                        : `Total: ${
                                            _vm.currentItems?.length ?? ""
                                          }`
                                    }`
                                  ) +
                                  "\n                    "
                              ),
                            ]
                          ),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: `group.header`,
                      fn: function ({ items, isOpen, toggle }) {
                        return [
                          items[0].family_id
                            ? _c(
                                "th",
                                { attrs: { colspan: _vm.headers.length + 1 } },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "flex font-weight-regular" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flex-col align-self-center mr-4",
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { on: { click: toggle } },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  isOpen ? "remove" : "add"
                                                ) +
                                                  "\n                                "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-list-item-subtitle",
                                        {
                                          staticClass:
                                            "flex align-self-center font-weight-bold soli-grey",
                                        },
                                        [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(
                                                `${items[0].last_name} Family`
                                              )
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                    {
                      key: `item.name`,
                      fn: function ({ item }) {
                        return [
                          _c("SoliListAvatar", {
                            attrs: {
                              avatar: item.profile_photo_path
                                ? `/api/image-service/40x40/${item.profile_photo_path}`
                                : item.profile_photo_url,
                              title: item.name,
                              subtitle: item.email,
                              href: `/profile/${item.id}/account`,
                            },
                          }),
                        ]
                      },
                    },
                    ["students", "prospects"].includes(_vm.role)
                      ? {
                          key: `item.purchaseOptions`,
                          fn: function ({ item }) {
                            return [
                              _c(
                                "v-list-item-subtitle",
                                {
                                  staticClass: "caption",
                                  staticStyle: { "max-width": "35vw" },
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(item.purchaseOptions) +
                                      "\n                    "
                                  ),
                                ]
                              ),
                            ]
                          },
                        }
                      : null,
                    _vm.can("Manage memberships") &&
                    ["students", "prospects"].includes(_vm.role)
                      ? {
                          key: `item.membershipPrices`,
                          fn: function ({ item }) {
                            return [
                              _c(
                                "v-list-item-subtitle",
                                { staticClass: "caption" },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(item.membershipPrices) +
                                      "\n                    "
                                  ),
                                ]
                              ),
                            ]
                          },
                        }
                      : null,
                    ["students", "prospects"].includes(_vm.role)
                      ? {
                          key: `item.tags`,
                          fn: function ({ item }) {
                            return [
                              _c(
                                "div",
                                { staticClass: "flex gap-1" },
                                _vm._l(item.tags, function (tag) {
                                  return _c(
                                    "v-chip",
                                    {
                                      key: tag.id,
                                      staticClass:
                                        "white--text font-weight-bold text-capitalize",
                                      attrs: {
                                        color: tag.color,
                                        "x-small": "",
                                      },
                                    },
                                    [_vm._v(_vm._s(tag.name))]
                                  )
                                }),
                                1
                              ),
                            ]
                          },
                        }
                      : null,
                    _vm.role == "teachers"
                      ? {
                          key: `item.instruments`,
                          fn: function ({ item }) {
                            return [
                              _c(
                                "v-list-item-subtitle",
                                {
                                  staticClass: "caption",
                                  staticStyle: { "max-width": "20vw" },
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(item.instruments) +
                                      "\n                    "
                                  ),
                                ]
                              ),
                            ]
                          },
                        }
                      : null,
                    _vm.role == "teachers"
                      ? {
                          key: `item.locations`,
                          fn: function ({ item }) {
                            return [
                              _c(
                                "v-list-item-subtitle",
                                {
                                  staticClass: "caption",
                                  staticStyle: { "max-width": "20vw" },
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(item.locations) +
                                      "\n                    "
                                  ),
                                ]
                              ),
                            ]
                          },
                        }
                      : null,
                    _vm.role == "teachers"
                      ? {
                          key: `item.certification_level`,
                          fn: function ({ item }) {
                            return [
                              _c(
                                "v-list-item-subtitle",
                                { staticClass: "caption" },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(item.certification_level) +
                                      "\n                    "
                                  ),
                                ]
                              ),
                            ]
                          },
                        }
                      : null,
                    _vm.role == "staff"
                      ? {
                          key: `item.staffRole`,
                          fn: function ({ item }) {
                            return [
                              _c(
                                "v-list-item-subtitle",
                                { staticClass: "caption" },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(item.staffRole) +
                                      "\n                    "
                                  ),
                                ]
                              ),
                            ]
                          },
                        }
                      : null,
                    {
                      key: `item.created_at`,
                      fn: function ({ item }) {
                        return [
                          _c(
                            "v-list-item-subtitle",
                            { staticClass: "caption" },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.globalMomentDate(item.created_at)
                                  ) +
                                  "\n                    "
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                    _vm.role == "teachers"
                      ? {
                          key: `item.capacity`,
                          fn: function ({ item }) {
                            return [
                              !_vm.capacityLoading
                                ? _c(
                                    "v-list-item-subtitle",
                                    { staticClass: "caption" },
                                    [
                                      _vm._v(
                                        "\n                        " +
                                          _vm._s(
                                            (item.capacity * 100).toFixed(2)
                                          ) +
                                          "%\n                    "
                                      ),
                                    ]
                                  )
                                : _c("v-progress-circular", {
                                    attrs: {
                                      size: "25",
                                      indeterminate: "",
                                      color: "primary",
                                    },
                                  }),
                            ]
                          },
                        }
                      : null,
                    _vm.role == "teachers"
                      ? {
                          key: `item.retention`,
                          fn: function ({ item }) {
                            return [
                              !_vm.retentionLoading
                                ? _c(
                                    "v-list-item-subtitle",
                                    {
                                      class: [item.retention.color, "caption"],
                                    },
                                    [
                                      _vm._v(
                                        "\n                        " +
                                          _vm._s(
                                            (
                                              Number(item.retention.value) * 100
                                            ).toFixed(2)
                                          ) +
                                          "%\n                        "
                                      ),
                                      _c(
                                        "v-icon",
                                        {
                                          class: item.retention.color,
                                          attrs: { small: "" },
                                        },
                                        [_vm._v(_vm._s(item.retention.icon))]
                                      ),
                                    ],
                                    1
                                  )
                                : _c("v-progress-circular", {
                                    attrs: {
                                      size: "25",
                                      indeterminate: "",
                                      color: "primary",
                                    },
                                  }),
                            ]
                          },
                        }
                      : null,
                    _vm.role == "teachers"
                      ? {
                          key: `item.hours`,
                          fn: function ({ item }) {
                            return [
                              !_vm.hoursLoading
                                ? _c(
                                    "v-list-item-subtitle",
                                    { staticClass: "caption" },
                                    [
                                      _vm._v(
                                        "\n                        " +
                                          _vm._s(item.hours) +
                                          "\n                    "
                                      ),
                                    ]
                                  )
                                : _c("v-progress-circular", {
                                    attrs: {
                                      size: "25",
                                      indeterminate: "",
                                      color: "primary",
                                    },
                                  }),
                            ]
                          },
                        }
                      : null,
                    _vm.role == "students"
                      ? {
                          key: `item.reschedules`,
                          fn: function ({ item }) {
                            return [
                              _c(
                                "v-list-item-subtitle",
                                {
                                  staticClass: "caption",
                                  staticStyle: { "max-width": "35vw" },
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(item.reschedules) +
                                      "\n                    "
                                  ),
                                ]
                              ),
                            ]
                          },
                        }
                      : null,
                  ],
                  null,
                  true
                ),
                model: {
                  value: _vm.selectedPeople,
                  callback: function ($$v) {
                    _vm.selectedPeople = $$v
                  },
                  expression: "selectedPeople",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }